module.exports = __webpack_public_path__ + "img/header_bg_mobile@2x.022d49ef.jpg";